export default {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'Linkedin',
  twitter: 'Twitter',
  youtube: 'Youtube',
  'follow-instagram': 'Suis-nous sur Instagram',
  'share-on': 'Partager sur',
  flyers: 'Flyers et tracts',
  'business-cards': 'Cartes de visite',
  'books-magazines': 'Revues, livres, catalogues',
}
